import { createValidator } from "revalidate";

export const isValidEmail = createValidator(
  (message) => (value) => {
    if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      return message;
    }
  },
  "Correo electrónico no válido"
);

export const isPasswordImprovedValid = createValidator(
  (message) => (value) => {

    const password = value?.password || "";

    if (!password) return message;

    // Fusiona espacios múltiples opcionalmente
    const normalized = password.replace(/\s+/g, ' ');

    // Cuenta caracteres Unicode correctamente
    //const length = [...normalized].length;
    let length = password.length; 
    if (length < 12 || length > 64) {
      return 'Contraseña debe tener entre 12 y 64 caracteres';
    }

    // Verifica que tenga al menos una letra y un número
    const hasLetterAndNumber = /(?=.*[A-Za-z])(?=.*\d)/u;

    if (!hasLetterAndNumber.test(normalized)) {
      return 'Contraseña debe contener al menos una letra y un número';
    }

    return undefined; // Contraseña válida
  }
, '');

export const isGreaterThanOrEqual = (n) =>
  createValidator(
    (message) => (value) => {
      if (String(value) && Number(value) < n) {
        return message;
      }
    },
    (field) => `${field} debe ser mayor o igual que ${n}`
  );

export const isLessThanOrEqual = (n) =>
  createValidator(
    (message) => (value) => {
      if (String(value) && Number(value) > n) {
        return message;
      }
    },
    (field) => `${field} debe ser menor o igual que ${n}`
  );

export const isBetween = (min, max) =>
  createValidator(
    (message) => (value) => {
      if ((String(value) && Number(value) < min) || Number(value) > max) {
        return message;
      }
    },
    (field) => `${field} debe estar entre ${min} y ${max}`
  );

export const isCuentaDestinoDiferente = (cuentaOrigen) =>
  createValidator(
    (message) => (value) => {
      if (value && cuentaOrigen === value) {
        return message;
      }
    },
    (field) => `${field} debe ser diferente que ${cuentaOrigen}`
  );

export const hasLengthEquals = (n) =>
  createValidator(
    (message) => (value) => {
      if (value && value.length !== n) {
        return message;
      }
    },
    (field) => `Longitud ${field} debe ser igual que ${n}`
  );

export const isCodigoCuentaInterbancarioValido = (bancos, bancoDestino) =>
  createValidator(
    (message) => (value) => {
      if (
        bancos &&
        bancos.length > 0 &&
        bancoDestino &&
        value &&
        value.length > 0
      ) {
        const digitosInicialesValidar = bancos.filter(
          (b) => b.codigo === bancoDestino
        )[0].digitoInicial;
        if (
          digitosInicialesValidar &&
          digitosInicialesValidar !== value.substr(0, 3)
        ) {
          return message;
        }
      }
    },
    (field) =>
      `Código de cuenta interbancario ${field} no válido para el banco destino ${bancoDestino}`
  );

export const isEqualValue = (firstValue, secondValue) =>
  createValidator(
    (message) => (value) => {
      if (firstValue && secondValue && firstValue !== secondValue) {
        return message;
      }
    },
    (field) => `Los valores son distintos`
  );

export const isTrueConditional = (aplicaCondicion) =>
  createValidator(
    (message) => (value) => {
      if (aplicaCondicion === true && value !== true) {
        return message;
      }
    },
    (field) => `El campo ${field} debe ser true`
  );

export const isGreaterThanOrEqualConditional = (n, aplicaCondicion) =>
  createValidator(
    (message) => (value) => {
      if (aplicaCondicion === true && String(value) && Number(value) < n) {
        return message;
      }
    },
    (field) => `${field} debe ser mayor o igual que ${n}`
  );
